import { render } from "./WorkBillBoard.vue?vue&type=template&id=b6772014"
import script from "./WorkBillBoard.vue?vue&type=script&lang=js"
export * from "./WorkBillBoard.vue?vue&type=script&lang=js"

import "./WorkBillBoard.vue?vue&type=style&index=0&id=b6772014&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__